export default "__VITE_ASSET__qKYMM8gV__"